import BaseModelInstance from './base.model'
import { UserExternalCarrier as ModelDefinition } from './model-definitions'

class UserExternalCarrier extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserExternalCarrier
